export enum EmbedLoginChoices {
  Other = 'other-wallets'
  // @TODO: add types for all torus verifiers
}
